import classnames from 'classnames';
import s from './index.module.scss';

export const OfferCard = ({
  children,
  icon,
  title,
  desc,
  modal,
  onLearnMore,
}) => {
  return (
    <div className={s.wrapper} onClick={onLearnMore}>
      <div className={s.left}>
        <img className={s.icon} src={icon} width={24} height={24} alt="icon" />
        <div className={s.content}>
          <div className={classnames(s.title, 'f-body-accent-s')}>{title}</div>
          <div className={classnames(s.desc, 'f-small-regular')}>{desc}</div>
        </div>
      </div>
      {children && <div className={s.right}>{children}</div>}
      {modal}
    </div>
  );
};
